"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
var _index = require("@/utils/index");
var _echarts = _interopRequireDefault(require("echarts"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CountTo: _vueCountTo.default
  },
  computed: {
    device: function device() {
      return this.$store.state.app.device;
    }
  },
  data: function data() {
    return {
      agentInfo: window.agentInfo,
      delComma: _index.delComma,
      totalData: {},
      todayData: {},
      yesterdayData: {},
      todayRatioData: {},
      loadingStates: {
        deposit: false,
        // 存量额
        turnover: false,
        // 交易额
        order: false,
        // 订单数
        user: false,
        // 用户数
        withdrawal: false,
        // 提现额
        profit: false // 分成额
      },
      // 分成额总览
      shopOverviewDialogVisible: false,
      // 控制对话框显示
      shopOverviewLoading: false,
      // 加载状态
      shopOverviewData: {},
      // 图表数据
      shopOverviewTimeRange: 'today',
      // 时间范围(默认今日的)
      shopOverviewDeviceType: 1,
      // 设备类型(默认充电宝)
      dateRange: null,
      // 日期范围
      isDateRangeChanged: false,
      // 标记日期范围是否变化
      deviceTypeChartLoading: false,
      // 设备类型图表加载状态
      shopChartLoading: false,
      // 分成项目图表加载状态
      deviceTypeData: {
        // 各设备类型的合计值
        charger: 0,
        // 充电桩
        powerBank: 0,
        // 充电宝
        chargingLine: 0,
        // 充电线
        condomMachine: 0 // 套套机
      },
      chargingPileAmount: 0,
      // 充电桩合计值
      chargingLineAmount: 0,
      // 充电线合计值
      powerBankAmount: 0,
      // 充电宝合计值
      condomMachineAmount: 0,
      // 套套机合计值
      totalDeviceTypeAmount: 0 // 所有设备类型合计值
    };
  },
  mounted: function mounted() {
    // this.getTotalData()
    // this.getTodayData()
    this.getToDayOnTotalData();
  },
  methods: {
    /** *
     * 异步获取所有的数据
     */
    getToDayOnTotalData: function () {
      var _getToDayOnTotalData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;
        var types, requests, results, typeMap, typeMapToday, typeMapYesterday, typeMapTodayRatio, totalData, todayData, yesterdayData, todayRatioData;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 设置所有加载状态为true
              Object.keys(this.loadingStates).forEach(function (key) {
                _this.loadingStates[key] = true;
              });
              _context.prev = 1;
              // 1存量额 2交易额 3订单数 4用户数 5提现额 6分成额
              types = [1, 2, 3, 4, 5, 6];
              requests = types.map(function (type) {
                return _this.$get('agentapi/data_overview/overview_index_statistics', {
                  aggs_type: type
                });
              });
              _context.next = 2;
              return Promise.all(requests);
            case 2:
              results = _context.sent;
              // 正确映射结果到对应的字段 - 总额
              typeMap = {
                1: 'total_cdb_user_balance',
                // 存量额
                2: 'total_order_amount',
                // 交易额
                3: 'total_order_num',
                // 订单数
                4: 'total_order_user_num',
                // 用户数
                5: 'available_withdraw_money',
                // 提现额
                6: 'total_profit' // 分成额
              }; // 映射结果到对应的字段 - 当天
              typeMapToday = {
                1: 'today_cdb_user_balance',
                // 存量额
                2: 'today_order_amount',
                // 交易额
                3: 'today_order_num',
                // 订单数
                4: 'today_order_user_num',
                // 用户数
                5: 'today_withdrawing_money',
                // 提现额
                6: 'today_profit' // 分成额
              }; // 映射结果到对应的字段 - 昨天
              typeMapYesterday = {
                1: 'yesterday_cdb_user_balance',
                // 存量额
                2: 'yesterday_order_amount',
                // 交易额
                3: 'yesterday_order_num',
                // 订单数
                4: 'yesterday_order_user_num',
                // 用户数
                5: 'yesterday_withdrawing_money',
                // 提现额
                6: 'yesterday_profit'
              }; // 环比值
              typeMapTodayRatio = {
                1: 'ratio_cdb_user_balance',
                // 存量额
                2: 'ratio_order_amount',
                // 交易额
                3: 'ratio_order_num',
                // 订单数
                4: 'ratio_order_user_num',
                // 用户数
                5: 'ratio_withdrawing_money',
                // 提现额
                6: 'ratio_profit' // 分成额
              };
              totalData = {};
              todayData = {};
              yesterdayData = {};
              todayRatioData = {};
              results.forEach(function (result, index) {
                var type = types[index];
                totalData[typeMap[type]] = result.total_num;
                todayData[typeMapToday[type]] = result.today_num;
                yesterdayData[typeMapYesterday[type]] = result.yesterday_num;
                todayRatioData[typeMapTodayRatio[type]] = result.today_ratio;
              });
              this.totalData = totalData;
              this.todayData = todayData;
              this.yesterdayData = yesterdayData;
              this.todayRatioData = todayRatioData;
            case 3:
              _context.prev = 3;
              // 设置所有加载状态为false
              Object.keys(this.loadingStates).forEach(function (key) {
                _this.loadingStates[key] = false;
              });
              return _context.finish(3);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function getToDayOnTotalData() {
        return _getToDayOnTotalData.apply(this, arguments);
      }
      return getToDayOnTotalData;
    }(),
    /**
     * 总数据
     */
    getTotalData: function getTotalData() {
      var _this2 = this;
      this.$get('agentapi/my_total_order_data').then(function (res) {
        _this2.totalData = res;
      });
    },
    getTodayData: function getTodayData() {
      var _this3 = this;
      this.$get('agentapi/my_today_order_data').then(function (res) {
        _this3.todayData = res;
      });
    },
    toWithdraw: function toWithdraw() {
      this.$router.push({
        path: "/withdraw/withdraw"
      });
    },
    /**
     * 显示分成额总览的对话框
     */
    shopRevieweShowDialog: function shopRevieweShowDialog() {
      var _this4 = this;
      this.shopOverviewDialogVisible = true;
      this.$nextTick(function () {
        _this4.fetchShopOverviewData();
        _this4.fetchTypeAmounts(); // 同时获取各设备类型合计值
      });
    },
    /**
     * 关闭分成额总览弹窗
     * @param done
     */
    handleShopOrderStatsClose: function handleShopOrderStatsClose(done) {
      var _this5 = this;
      this.$confirm('确认关闭？').then(function (_) {
        _this5.shopOverviewDialogVisible = false;
        done();
      }).catch(function (_) {});
    },
    /**
     * 获取分成额总览数据
     */
    fetchShopOverviewData: function fetchShopOverviewData() {
      var _this6 = this;
      this.shopOverviewLoading = true;
      this.shopChartLoading = true; // 设置下面图表的加载状态

      var params = {
        user_type: this.user_type,
        device_type: this.shopOverviewDeviceType
      };

      // 根据时间范围选择设置参数
      if (this.dateRange && this.dateRange.length === 2) {
        params.period = this.dateRange[0] + '|' + this.dateRange[1];
      } else {
        params.period = this.shopOverviewTimeRange;
      }
      this.$get('agentapi/data_overview/overview_commission_amount', params).then(function (res) {
        _this6.shopOverviewData = res;

        // 根据当前设备类型更新对应的合计值，避免重复请求
        switch (_this6.shopOverviewDeviceType) {
          case 5:
            // 充电桩
            _this6.chargingPileAmount = res.total_amount || 0;
            break;
          case 3:
            // 充电线
            _this6.chargingLineAmount = res.total_amount || 0;
            break;
          case 1:
            // 充电宝
            _this6.powerBankAmount = res.total_amount || 0;
            break;
          case 9:
            // 套套机
            _this6.condomMachineAmount = res.total_amount || 0;
            break;
        }
        _this6.$nextTick(function () {
          // 在设备类型变化时只更新下面的图表，在日期范围变化时更新两个图表
          _this6.initShopChart(); // 总是更新下面的图表
          if (_this6.isDateRangeChanged) {
            _this6.initDeviceTypeChart(); // 只有在日期范围变化时才更新上面的图表
          }
          _this6.isDateRangeChanged = false; // 重置标志
        });
      }).catch(function (err) {
        console.error('获取分成额总览数据失败:', err);
        _this6.$message.error('获取分成额总览数据失败');
      }).finally(function () {
        _this6.shopOverviewLoading = false;
        _this6.shopChartLoading = false; // 移除下面图表的加载状态
      });
    },
    /**
     * 获取各类型合计值
     */
    fetchTypeAmounts: function () {
      var _fetchTypeAmounts = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this7 = this;
        var deviceTypes, requests, results;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.deviceTypeChartLoading = true; // 设置加载状态

              // 定义设备类型映射
              deviceTypes = [{
                type: 5,
                name: '充电桩'
              }, {
                type: 3,
                name: '充电线'
              }, {
                type: 1,
                name: '充电宝'
              }, {
                type: 9,
                name: '套套机'
              }]; // 并发请求所有类型的数据
              requests = deviceTypes.map(function (deviceType) {
                var params = {
                  user_type: _this7.user_type,
                  device_type: deviceType.type
                };

                // 根据时间范围选择设置参数
                if (_this7.dateRange && _this7.dateRange.length === 2) {
                  params.period = _this7.dateRange[0] + '|' + _this7.dateRange[1];
                } else {
                  params.period = _this7.shopOverviewTimeRange;
                }
                return _this7.$get('agentapi/data_overview/overview_commission_amount', params).then(function (res) {
                  return {
                    type: deviceType.type,
                    name: deviceType.name,
                    amount: res.total_amount || 0
                  };
                }).catch(function (err) {
                  console.error("\u83B7\u53D6".concat(deviceType.name, "\u6570\u636E\u5931\u8D25:"), err);
                  return {
                    type: deviceType.type,
                    name: deviceType.name,
                    amount: 0
                  };
                });
              }); // 执行所有请求
              _context2.next = 1;
              return Promise.all(requests);
            case 1:
              results = _context2.sent;
              // 更新各类型合计值
              results.forEach(function (result) {
                switch (result.type) {
                  case 5:
                    _this7.chargingPileAmount = result.amount;
                    break;
                  case 3:
                    _this7.chargingLineAmount = result.amount;
                    break;
                  case 1:
                    _this7.powerBankAmount = result.amount;
                    break;
                  case 9:
                    _this7.condomMachineAmount = result.amount;
                    break;
                }
              });

              // 初始化设备类型柱状图
              this.$nextTick(function () {
                _this7.updateTotalDeviceTypeAmount(); // 更新合计值
                _this7.initDeviceTypeChart();
                // 确保移除加载状态
                _this7.deviceTypeChartLoading = false;
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchTypeAmounts() {
        return _fetchTypeAmounts.apply(this, arguments);
      }
      return fetchTypeAmounts;
    }(),
    /**
     * 初始化设备类型柱状图
     */
    initDeviceTypeChart: function initDeviceTypeChart() {
      this.deviceTypeChartLoading = true; // 设置加载状态

      var echarts = require('echarts');

      // 销毁已有实例
      if (this.deviceTypeChartInstance) {
        this.deviceTypeChartInstance.dispose();
      }

      // 初始化图表
      var chartContainer = this.$refs.deviceTypeChartContainer;
      if (!chartContainer) {
        this.deviceTypeChartLoading = false; // 移除加载状态
        return;
      }
      this.deviceTypeChartInstance = echarts.init(chartContainer);

      // 准备数据
      var categories = ['充电桩', '充电线', '充电宝', '套套机'];
      var amounts = [this.chargingPileAmount, this.chargingLineAmount, this.powerBankAmount, this.condomMachineAmount];

      // 图表配置
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function formatter(params) {
            var tooltip = params[0].name + '<br/>';
            tooltip += params[0].marker + params[0].seriesName + ': ¥' + params[0].value.toFixed(2);
            return tooltip;
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: categories,
          name: '',
          nameLocation: 'middle',
          nameGap: 30,
          axisLabel: {
            interval: 0,
            rotate: 0,
            margin: 20,
            fontSize: 14,
            fontWeight: 'normal',
            // 确保文字完整显示
            overflow: 'breakAll',
            width: 80,
            align: 'center'
          }
        },
        yAxis: {
          type: 'value',
          name: '金额(元)',
          axisLabel: {
            formatter: '¥{value}'
          }
        },
        series: [{
          name: '分成金额',
          type: 'bar',
          data: amounts,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#83bff6'
            }, {
              offset: 0.5,
              color: '#188df0'
            }, {
              offset: 1,
              color: '#188df0'
            }])
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#2378f7'
              }, {
                offset: 0.7,
                color: '#2378f7'
              }, {
                offset: 1,
                color: '#83bff6'
              }])
            }
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return '¥' + params.value.toFixed(2);
            }
          }
        }]
      };
      this.deviceTypeChartInstance.setOption(option);
      this.updateTotalDeviceTypeAmount(); // 更新合计值
      this.deviceTypeChartLoading = false; // 移除加载状态
    },
    /**
     * 初始化分成额总览的图表
     */
    initShopChart: function initShopChart() {
      this.shopChartLoading = true; // 设置加载状态

      var echarts = require('echarts');

      // 销毁已有实例
      if (this.shopChartInstance) {
        this.shopChartInstance.dispose();
      }

      // 初始化图表
      var chartContainer = this.$refs.shopChartContainer;
      if (!chartContainer) {
        this.shopChartLoading = false; // 移除加载状态
        return;
      }
      this.shopChartInstance = echarts.init(chartContainer);

      // 处理数据
      var categories = ['平台分佣', '投资分佣', '增值分佣', '手续费'];
      var amounts = [this.shopOverviewData.platform_commission || 0, this.shopOverviewData.investment_commission || 0, this.shopOverviewData.value_added_commission || 0, this.shopOverviewData.service_charge || 0];

      // 图表配置
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function formatter(params) {
            var tooltip = params[0].name + '<br/>';
            tooltip += params[0].marker + params[0].seriesName + ': ¥' + params[0].value.toFixed(2);
            return tooltip;
          }
        },
        xAxis: {
          type: 'category',
          data: categories
        },
        yAxis: {
          type: 'value',
          name: '金额(元)'
        },
        series: [{
          name: '分成金额',
          type: 'bar',
          data: amounts,
          itemStyle: {
            color: '#5470c6'
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return '¥' + params.value.toFixed(2);
            }
          }
        }]
      };
      this.shopChartInstance.setOption(option);
      this.shopChartLoading = false; // 移除加载状态
    },
    /**
     * 更新所有设备类型的合计值
     */
    updateTotalDeviceTypeAmount: function updateTotalDeviceTypeAmount() {
      this.totalDeviceTypeAmount = parseFloat((this.chargingPileAmount + this.chargingLineAmount + this.powerBankAmount + this.condomMachineAmount).toFixed(2));
    },
    /**
     * 处理设备类型变化
     */
    handleDeviceTypeChange: function handleDeviceTypeChange() {
      this.shopChartLoading = true; // 设置下面图表的加载状态
      this.fetchShopOverviewData();
      // this.fetchTypeAmounts(); // 同时更新各设备类型数据
    },
    /**
     * 处理日期范围变化
     */
    handleDateRangeChange: function handleDateRangeChange() {
      if (this.dateRange) {
        // 设置为自定义时间范围
        this.shopOverviewTimeRange = 'custom';
        this.isDateRangeChanged = true; // 标记日期范围已变化
        this.deviceTypeChartLoading = true; // 设置上面图表的加载状态
        this.fetchShopOverviewData();
        this.fetchTypeAmounts(); // 同时更新各设备类型数据
      }
    }
  }
};